const i=({spacing:e})=>({styleOverrides:{root:{minWidth:e(2.5),marginRight:e(1.5)}}});export{i as default};
